export const AUTHORIZED_MAIN_SCROLL_ID = 'authorized-layout-main';

export function scrollAuthorizedMainToTop(): void {
	document.getElementById(AUTHORIZED_MAIN_SCROLL_ID)?.scrollTo({top: 0, left: 0});
}
